import type { FC } from 'react';

import { NavigationMenu, NavigationMenuWrapper } from '@eneco/custom-components/MegaMenu';
import { Grid, Stack } from '@eneco/sparky';
import { useMediaQuery } from '@eneco/sparky/hooks';
import { useI18nTranslation } from '@eneco/sparky/providers';
import { MegaMenuV2Rendering } from '@sitecore/types/manual/MegaMenuV2';

import MegaMenuV2Division from '../MegaMenuV2Division/MegaMenuV2Division';


const MegaMenuV2: FC<MegaMenuV2Rendering> = ({ fields }) => {
  const mainNavigation = useI18nTranslation('mainNavigation');
  const isDesktop = useMediaQuery('lg');
  const items = fields.items || [];

  return isDesktop ? (
    <NavigationMenuWrapper>
      <NavigationMenu.Root aria-label={mainNavigation}>
        <NavigationMenu.List asChild>
          <Stack as="ul" direction="row" gap="6">
            {items.map(item => (
              <NavigationMenu.Item key={item.id}>
                <MegaMenuV2Division fields={item.fields} />
              </NavigationMenu.Item>
            ))}
          </Stack>
        </NavigationMenu.List>
      </NavigationMenu.Root>
    </NavigationMenuWrapper>
  ) : (
    <Stack gap="7" direction={{ md: items.length > 0 ? 'row' : 'column' }}>
      <Stack.Item as="nav" grow aria-label={mainNavigation}>
        <Grid as="ul" gridTemplateColumns={{ md: items.length > 0 ? '1fr' : '1fr 1fr' }} gap="5">
          {items.map(item => (
            <li key={item.id}>
              <MegaMenuV2Division fields={item.fields} />
            </li>
          ))}
        </Grid>
      </Stack.Item>
    </Stack>
  );
};

export { MegaMenuV2 };
export default MegaMenuV2;
